module.exports = __webpack_public_path__ + "4679c399368d9ad477acea33918195ec.svg";